/* eslint-disable */

import firebase from 'firebase'
import firestore from 'firebase/firestore'

var config = {
    apiKey: "AIzaSyCC6_FVKi6Shsc7SWkN2aoIAXvPXtKGx6I",
    authDomain: "twenty20-buzz.firebaseapp.com",
    databaseURL: "https://twenty20-buzz.firebaseio.com",
    projectId: "twenty20-buzz",
    storageBucket: "twenty20-buzz.appspot.com",
    messagingSenderId: "53679600672",
    appId: "1:53679600672:web:c99eecc83622f91a163845",
    measurementId: "G-HSG5TX11HD"
};

const firebaseApp = firebase.initializeApp(config);

export default firebaseApp.firestore()